// The Slovenian texts are the prototype's own, word for word where a screen matches.
export default {
    offer: {
        save_hint: 'Der Druckdialog öffnet sich — wählen Sie als Ziel „Als PDF speichern“.',
        invalid_title: 'Angebot nicht verfügbar',
        invalid_text: 'Der Link zum Angebot ist abgelaufen oder wurde ersetzt. Bitte wenden Sie sich an das Hotel.',
        eyebrow: 'Angebot für die Gruppe',
        eyebrow_reservation: 'Angebot für Sie',
        nights: 'Übernachtungen',
        financials: 'Angebot',
        col_item: 'Position',
        col_quantity: 'Menge',
        col_price: 'Preis/Einheit',
        col_discount: 'Rabatt',
        col_vat: 'MwSt.',
        col_amount: 'Betrag',
        total_net: 'Gesamt ohne MwSt.',
        vat_at: 'MwSt. {rate} %',
        remaining: 'Zu zahlen',
        rooms: 'Unterkunft',
        per_night: 'Nacht',
        up_to: 'bis zu {count} Personen im Zimmer',
        total: 'Gesamt',
        paid: 'Bereits bezahlt',
        services: 'Leistungen des Hauses',
        included: 'für Gäste verfügbar',
        valid_until: 'Das Angebot gilt bis {date}.',
        contact: 'Fragen und Bestätigung',
        print: 'Drucken',
        save: 'PDF speichern',
        confirm: 'Angebot bestätigen',
        confirmed_at: 'Angebot am {date} bestätigt. Vielen Dank — das Hotel wurde benachrichtigt.',
        units: { hour: 'Stunde', day: 'Tag', night: 'Nacht', person: 'Person', use: 'Nutzung', item: 'Stück', treatment: 'Anwendung' },
    },
    rooming: {
        pick: 'Auswählen …',
        invalid_title: 'Link ungültig',
        invalid_text: 'Der Link zur Gästeeingabe ist abgelaufen oder wurde ersetzt. Bitte wenden Sie sich an das Hotel.',
        intro: 'Tragen Sie die Gäste Ihrer Gruppe ein. Das Hotel prüft die Liste und teilt die Zimmer zu — ein Eintrag hier ist noch keine Reservierung.',
        add_title: 'Gast hinzufügen',
        first_name: 'Vorname',
        last_name: 'Nachname',
        email: 'E-Mail',
        phone: 'Telefon',
        notes: 'Anmerkungen',
        add: 'Hinzufügen',
        added: 'Der Gast wurde zur Liste hinzugefügt.',
        failed: 'Der Eintrag konnte nicht gespeichert werden.',
        entered: 'Eingetragene Gäste ({count})',
        none_yet: 'Noch keine Gäste eingetragen.',
        booking_title: 'Mitreisende eintragen',
        rooms_title: 'Zimmer',
        rooms_count: '{count} Zimmer',
        filled_of: '{filled} von {capacity} eingetragen',
        pick_room_first: 'Wählen Sie zuerst oben ein Zimmer.',
        adding_to: 'Hinzufügen zu: {room}',
        unassigned: 'Nicht zugeteilt',
        date_of_birth: 'Geburtsdatum',
        nationality: 'Staatsangehörigkeit',
        nationality_hint: 'z. B. SI',
        document_type: 'Dokumentart',
        document_type_hint: 'z. B. Reisepass',
        document_number: 'Dokumentnummer',
        confirmed: 'Bestätigt',
        booked_note: 'Bereits zugeteilte Gäste sind vom Hotel bestätigt; Änderungen melden Sie bitte der Rezeption.',
        register_hint: 'Geburtsdatum, Staatsangehörigkeit und Dokument benötigen wir für die gesetzlich vorgeschriebene Gästemeldung. Die Daten prüfen wir bei der Ankunft an der Rezeption.',
    },
    keys: {
        title: 'Schlüssel',
        your_room: 'IHR ZIMMER',
        your_pin: 'IHR PIN-CODE',
        pin_text: 'Mit dem PIN-Code öffnen Sie alle Ihre Türen, oder Sie nutzen die Fernöffnung unten.',
        your_keys: 'IHRE SCHLÜSSEL',
        door_room: 'Zimmer',
        room_on_arrival: 'bei Ankunft zugeteilt',
        hold: 'Zum Entsperren gedrückt halten',
        unlocked: 'Entsperrt',
        preview_note: 'Die Fernöffnung funktioniert, sobald das Haus die Schlösser mit dem System verbindet — bis dahin ist es eine Vorschau.',
        demo_done: 'Vorschau — die Schlösser sind noch nicht verbunden.',
    },
    nav: {
        menu: 'Menü',
        roomservice_hint: 'Speisen und Getränke direkt aufs Zimmer',
        roomservice: 'Zimmerservice',
        keys: 'Schlüssel',
        short_keys: 'Schlüssel',
        overview: 'Übersicht',
        checkin: 'Check-in',
        stay: 'Mein Aufenthalt',
        arrival: 'Anreise',
        services: 'Leistungen',
        payments: 'Zahlungen und Rechnungen',
        short_overview: 'Übersicht',
        short_checkin: 'Check-in',
        short_arrival: 'Anreise',
        short_services: 'Leistungen',
        short_payments: 'Rechnung',
        house: 'Das Haus',
    },
    general: {
        back: 'Zurück',
        cancel: 'Abbrechen',
        close: 'Schließen',
        save_failed: 'Speichern fehlgeschlagen. Bitte versuchen Sie es erneut.',
    },
    theme: {
        title: 'Helles/dunkles Design',
        to_dark: 'Dunkles Design aktivieren',
        to_light: 'Helles Design aktivieren',
    },
    overview: {
        eyebrow: 'IHR NÄCHSTER AUFENTHALT',
        language: 'Sprache',
        welcome: 'Willkommen im',
        welcome_named: 'Willkommen, {names}',
        and: 'und',
        subtitle: 'Hier erledigen Sie alles vor der Ankunft und während des Aufenthalts.',
        arrival: 'ANREISE',
        departure: 'ABREISE',
        reservation: 'RESERVIERUNG',
        ready: 'Bereit zur Ankunft',
        almost: 'Bereit zur Ankunft',
        all_done: 'Alles erledigt',
        one_more_step: 'Noch ein Schritt',
        steps_left_two: 'Noch 2 Schritte',
        steps_left_few: 'Noch {n} Schritte',
        step_profile: 'Persönliche Daten',
        step_document: 'Dokument',
        step_payment: 'Zahlung',
        finish_checkin: 'Check-in abschließen',
        card_checkin: 'Online-Check-in',
        card_checkin_text: 'Vervollständigen Sie die Gästedaten und verkürzen Sie den Vorgang an der Rezeption.',
        card_checkin_go: 'Check-in fortsetzen',
        card_stay: 'Mein Aufenthalt',
        card_stay_text: 'Zimmer, Ankunftszeit, besondere Wünsche und Anreisehinweise.',
        card_stay_go: 'Reservierung ansehen',
        card_services: 'Hotelleistungen',
        card_services_text: 'Massage, Sauna, Abendessen oder Fahrradverleih.',
        card_services_go: 'Leistungen entdecken',
        card_room_service: 'Zimmerservice',
        card_room_service_text: 'Speisen und Getränke aus der Hotelküche, direkt aufs Zimmer.',
        card_room_service_go: 'Zur Speisekarte',
        card_money: 'Kosten und Zahlungen',
        card_money_go: 'Rechnung und Zahlung öffnen',
        card_keys_title: 'Schlüssel',
        card_keys_none: 'Schlüssel und PIN-Code erwarten Sie nach dem Check-in und der Zimmerzuteilung.',
        card_keys_get: 'Schlüssel erhalten',
        card_keys_go: 'Alle Schlüssel und PIN',
        card_arrival: 'Anreise und Lage',
        card_arrival_text: 'Adresse, Navigation sowie Fotos von Eingang, Parkplatz und Garage.',
        card_arrival_go: 'Anreisehinweise ansehen',
        card_house: 'Das Haus und die Umgebung',
        card_house_text: 'WLAN, Öffnungszeiten, Willkommensbrief, Preisliste und was in der Stadt los ist.',
        card_house_go: 'Hausinformationen öffnen',
        partly_paid: 'Teilweise bezahlt',
        charges: 'Aufenthaltskosten',
        parking_charges: 'Parkkosten',
        paid: 'Bezahlt',
        balance: 'Restbetrag',
    },
    checkin: {
        pick: 'Auswählen …',
        title: 'Online-Check-in',
        subtitle: 'Die Daten werden sicher direkt an das Hotel übertragen.',
        step_guests: 'Gäste',
        step_documents: 'Dokumente',
        step_payment: 'Zahlung',
        step_confirm: 'Bestätigung',
        guests_title: 'Gäste der Reservierung',
        unnamed: 'Gast ohne Namen',
        document_read: 'Dokument gelesen · Daten vollständig',
        document_missing: 'Dokument fehlt',
        document_entered: 'Daten eingegeben · die Rezeption prüft sie bei der Ankunft',
        done_badge: 'Fertig',
        add_document: 'Daten eingeben',
        add_companion: 'Begleitperson hinzufügen',
        first_name: 'Vorname',
        last_name: 'Nachname',
        companion_hint: 'Fügen Sie eine Person hinzu, die mit Ihnen wohnt. Das Dokument geben Sie im nächsten Schritt ein, genau wie bei sich selbst.',
        companion_room: 'Zimmer',
        companion_save: 'Person hinzufügen',
        companion_saved: 'Person hinzugefügt — geben Sie nun ihr Dokument ein.',
        companion_incomplete: 'Geben Sie Vor- und Nachnamen ein (und wählen Sie das Zimmer).',
        companion_failed: 'Die Person konnte nicht hinzugefügt werden — das Zimmer ist vielleicht schon voll. Bitte wenden Sie sich an die Rezeption.',
        wishes_title: 'Ankunft und Wünsche',
        expected_arrival: 'Voraussichtliche Ankunft',
        phone: 'Mobilnummer',
        phone_placeholder: '+386 41 234 567',
        wishes: 'Besondere Wünsche',
        wishes_placeholder: 'Ruhiges Zimmer, höhere Etage',
        plate: 'Kennzeichen',
        plate_hint: 'Falls Sie ein Auto auf dem Parkplatz oder in der Garage abstellen.',

        // Marketing consent (docs/MARKETING.md §13). Never pre-ticked.
        consent_title:  'Angebote per E-Mail',
        consent_label:  'Ich möchte Angebote und Neuigkeiten des Hotels per E-Mail erhalten.',
        consent_hint:   'Sie können dies jederzeit widerrufen — auch mit einem Klick am Ende jeder E-Mail. Nachrichten zu Ihrer Buchung erhalten Sie in jedem Fall.',
        consent_failed: 'Die Einwilligung konnte nicht gespeichert werden.',
        save_for_later: 'Für später speichern',
        continue_payment: 'Weiter zur Zahlung',
        saved: 'Der Check-in ist gespeichert.',
        doc_title: 'Dokument hinzufügen',
        doc_type: 'Dokumentart',
        doc_number: 'Dokumentnummer',
        doc_nationality: 'Staatsangehörigkeit',
        doc_nationality_hint: 'Zweistelliger Ländercode, z. B. SI, DE, IT.',
        doc_birth: 'Geburtsdatum',
        doc_save: 'Daten speichern',
        doc_saved: 'Das Dokument ist gespeichert.',
        doc_incomplete: 'Füllen Sie alle Felder aus — ohne sie kann die Gästemeldung nicht abgegeben werden.',
        doc_hint: 'Lesen Sie das Dokument mit der App Imprion ID Scan ein oder geben Sie die Daten von Hand ein. Das Foto wird nicht gespeichert.',
        doc_manual: 'Manuelle Eingabe',
        doc_idscan: 'ID Scan öffnen',
        doc_coming: 'Das Einlesen des Dokuments über das Portal kommt bald — bis dahin wird das Dokument an der Rezeption gelesen.',
    },
    stay: {
        requests_title: 'IHRE ANFRAGEN',
        request_extension: 'Verlängerung um {nights} Nächte',
        request_late_checkout: 'Später Check-out',
        request_pending: 'wartet auf die Rezeption',
        request_confirmed: 'bestätigt',
        request_declined: 'leider nicht möglich',
        title: 'Mein Aufenthalt',
        room: 'Zimmer',
        room_assigned_on_arrival: 'Das Zimmer wird bei der Ankunft zugeteilt',
        occupancy: '{adults} Erwachsene · {children} Kinder',
        expected: 'erwartet {hour}',
        late_checkout: 'Späten Check-out anfragen',
        room_released_title: 'Auszug aus dem Zimmer',
        room_released_text: 'Sie sind ausgecheckt, das Zimmer ist bei uns aber noch als belegt vermerkt. Sobald Sie uns mitteilen, dass Sie es verlassen haben, bereiten wir es für den nächsten Gast vor.',
        room_released: 'Ich habe das Zimmer verlassen',
        room_released_sent: 'Danke - wir haben weitergegeben, dass das Zimmer frei ist.',
        extension_check: 'Mögliche Verlängerung prüfen',
        extension_title: 'Aufenthalt verlängern',
        extension_hint: 'Prüfen Sie, ob die Nächte nach Ihrer Abreise noch frei sind. Der Wunsch geht an die Rezeption, die die Verlängerung bestätigt — es wird nichts automatisch reserviert.',
        extension_same_room: 'Frei — Sie können im selben Zimmer bleiben',
        extension_other_room: 'Frei — mit Zimmerwechsel',
        extension_full: 'Leider sind für diese Nächte keine Zimmer frei.',
        extension_price: 'Schätzung {amount}/Nacht nach Ihrem Paket',
        extension_request: 'Verlängerung um +{nights} anfragen',
        extension_sent: 'Ihr Verlängerungswunsch wurde an die Rezeption gesendet — man wird sich bei Ihnen melden.',
        late_checkout_sent: 'Die Anfrage für einen späten Check-out wurde gesendet.',
        call: 'Anrufen',
        status_booked: 'Reserviert',
        status_confirmed: 'Bestätigt',
        status_checked_in: 'Eingecheckt',
        status_checked_out: 'Ausgecheckt',
    },
    parking: {
        maps_card: 'Lage und Navigation in Google Maps',
        card_title: 'Parken',
        card_title_both: 'Parken und Garage',
        card_text: 'Geben Sie das Kennzeichen ein, damit sich die Schranke bei der Ankunft und während des Aufenthalts automatisch öffnet.',
        add: 'Kennzeichen hinzufügen',
        change: 'Zugang ändern oder hinzufügen',
        active_badge: 'Schranke aktiv',
        active_until: 'Die automatische Einfahrt ist bis {date} aktiv.',
        title: 'Automatische Garageneinfahrt',
        hint: 'Die Kamera an der Schranke erkennt während Ihres Aufenthalts das Kennzeichen und öffnet die Schranke automatisch.',
        maps: 'In Google Maps öffnen',
        copy: 'Adresse kopieren',
        copied: 'Die Adresse wurde kopiert.',
        plate: 'Fahrzeugkennzeichen',
        placeholder: 'z. B. MB AB-123',
        validity: 'Gültigkeit des Zugangs',
        validity_range: '{from} bis {to}',
        activate: 'Bestätigen und aktivieren',
        activated: 'Das Kennzeichen {plate} ist für die automatische Einfahrt aktiviert.',
        check_plate: 'Bitte überprüfen Sie das Kennzeichen.',
        extra_cars: 'Weitere Fahrzeuge',
        add_car: 'Weiteres Auto hinzufügen',
        remove_car: 'Entfernen',
        removed: 'Das Kennzeichen wurde entfernt; die Schranke öffnet sich dafür nicht mehr.',
        removed_booking_kept: 'Das Kennzeichen wurde entfernt. Die Parkplatzreservierung kann über das Portal nicht mehr storniert werden — die Rezeption erledigt das.',
        first_car_price: 'Parkplatz für den Aufenthalt: {amount}. Der Betrag wird auf die Aufenthaltsrechnung gebucht.',
        included_note: 'Das Parken ist im Übernachtungspreis enthalten.',
        remove_car_done: 'Die Reservierung für {plate} wurde storniert und von der Aufenthaltsrechnung abgezogen.',
        add_car_price: 'Parkplatz für den Rest des Aufenthalts: {amount}. Der Betrag wird auf die Aufenthaltsrechnung gebucht.',
        add_car_book: 'Reservieren und zur Rechnung hinzufügen',
        add_car_done: 'Der Parkplatz für {plate} ist reserviert und auf die Aufenthaltsrechnung gebucht.',
    },
    arrival: {
        title: 'Anreise zum Hotel',
        navigate: 'Navigation',
        back_to_stay: 'Zurück zum Aufenthalt',
        entrance_title: 'Haupteingang',
        entrance_text: 'Kurzer Halt für das Gepäck und stufenloser Zugang.',
        parking_title: 'Außenparkplatz',
        parking_text: 'Einfahrt mit Ihrem eigenen Kennzeichen.',
        garage_title: 'Garageneinfahrt',
        garage_text: 'Die Schranke öffnet sich automatisch, sobald die Kamera das Fahrzeugkennzeichen erkennt.',
    },
    services: {
        room_service_link: 'Zimmerservice',
        title: 'Leistungen und Erlebnisse',
        subtitle: 'Leistungen können direkt auf die Aufenthaltsrechnung gebucht werden.',
        loading: 'Angebot wird geladen …',
        booked_title: 'BEREITS GEBUCHT',
        edit: 'Bearbeiten',
        edit_close: 'Bearbeiten schließen',
        edit_save: 'Änderung bestätigen',
        edit_hint: 'Neue Tage wählen; ein zusammenhängender Zeitraum ohne Lücken.',
        edit_gap: 'Zusammenhängende Tage wählen — für zwei getrennte Zeiträume erstellen Sie zwei Reservierungen.',
        edited: 'Die Reservierung wurde verschoben.',
        edit_failed: 'Die Änderung konnte nicht durchgeführt werden — die Tage sind vielleicht schon belegt. Prüfen Sie die Liste.',
        desk_only_now: 'Änderung oder Stornierung nur noch über die Rezeption.',
        withdraw: 'Stornieren',
        withdrawn: 'Die Reservierung ist storniert. Falls sie bereits berechnet wurde, ist der Betrag storniert.',
        withdraw_failed: 'Die Stornierung konnte nicht durchgeführt werden — bitte wenden Sie sich an die Rezeption.',
        policy_until_start: 'Kostenlose Stornierung über das Portal bis zum Beginn.',
        policy_hours: 'Kostenlose Stornierung über das Portal bis {hours} h vor Beginn.',
        policy_desk_only: 'Stornierung nur über die Rezeption.',
        quantity: 'Wie viele',
        per_days: '/ {days} Tage',
        days_count: '{days} Tage',
        full_days: 'Belegt: {days}',
        plate_nth: 'Kennzeichen des {number}. Fahrzeugs',
        per_day: '/ Tag',
        stay_total: '{amount} für {nights} Tage',
        book: 'Für den Aufenthalt reservieren',
        full: 'Für Ihren Aufenthalt sind keine Plätze mehr frei.',
        none: 'Das Haus bietet derzeit keine Leistungen an, die über das Portal reserviert werden können. Für Termine (Massage, Abendessen) wenden Sie sich an die Rezeption.',
        confirm_text: 'Reservierung für den gesamten Aufenthalt, {from}–{to}. Der Betrag {amount} wird auf Ihre Hotelrechnung gebucht.',
        confirm: 'Reservierung bestätigen',
        cancel: 'Abbrechen',
        needs_plate: 'Geben Sie das Fahrzeugkennzeichen ein.',
        booked: 'Reserviert. Die Leistung steht auf Ihrer Aufenthaltsrechnung.',
        book_failed: 'Die Reservierung ist fehlgeschlagen — versuchen Sie es erneut oder wenden Sie sich an die Rezeption.',
        status_booked: 'reserviert',
        status_in_progress: 'in Bearbeitung',
        status_completed: 'erledigt',
        status_cancelled: 'storniert',
        status_no_show: 'nicht genutzt',
    },
    room_service: {
        categories: 'Speisekarte',
        my_orders: 'Ihre Bestellungen',
        basket_open: 'Warenkorb',
        basket_title: 'Ihre Bestellung',
        when: 'Lieferzeit',
        when_asap: 'So bald wie möglich',
        when_today: 'Heute um {time}',
        when_tomorrow: 'Morgen um {time}',
        closed_now_later: 'Die Küche serviert gerade nicht — Sie können für später bestellen.',
        ordered_at: 'bestellt {when}',
        deliver_for: 'Lieferung {when}',
        ordered_for: 'Bestellung für {time} angenommen — {amount} auf Ihrer Zimmerrechnung.',
        title: 'Zimmerservice',
        subtitle: 'Bestellen Sie aus der Hotelküche — der Betrag geht auf Ihre Zimmerrechnung.',
        loading: 'Speisekarte wird geladen …',
        load_failed: 'Die Speisekarte konnte nicht geladen werden. Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
        retry: 'Erneut versuchen',
        to_room: 'LIEFERUNG AUF ZIMMER {room}',
        hours: 'Küche heute: {hours}',
        shut_today: 'heute geschlossen',
        closed_now: 'Die Küche nimmt gerade keine Bestellungen an. Bitte versuchen Sie es während der Öffnungszeiten.',
        less: 'Eins entfernen',
        more: 'Eins hinzufügen',
        empty_menu: 'Das Hotel hat der Speisekarte noch nichts hinzugefügt.',
        basket: 'IHRE BESTELLUNG',
        basket_empty: 'Mit + fügen Sie Speisen oder Getränke hinzu.',
        total: 'Gesamt',
        note: 'Nachricht an die Küche',
        note_placeholder: 'z. B. ohne Zwiebeln, zwei Bestecke',
        terms: 'Mit der Bestätigung erhält die Küche die Bestellung; der Betrag geht auf die Zimmerrechnung und wird beim Check-out bezahlt.',
        order: 'Bestellen · {amount}',
        sending: 'Wird gesendet …',
        clear: 'Leeren',
        orders: 'IHRE BESTELLUNGEN',
        ordered: 'Bestellung angenommen — {amount} auf Ihrer Zimmerrechnung.',
        retry_hint: 'Es kam keine Antwort. Drücken Sie erneut auf Bestellen — die Bestellung wird nicht doppelt aufgegeben.',
        failed: 'Die Küche hat die Bestellung nicht angenommen. Prüfen Sie sie und versuchen Sie es erneut oder rufen Sie die Rezeption an.',
        not_offered: 'Das Hotel bietet über dieses Portal keinen Zimmerservice an. Bitte rufen Sie zum Bestellen die Rezeption an.',
        not_in_house: 'Der Zimmerservice steht nach dem Check-in zur Verfügung.',
        menu_unreadable: 'Die Speisekarte kann gerade nicht gelesen werden. Versuchen Sie es in einigen Minuten erneut oder rufen Sie die Rezeption an.',
    },
    stay_services: {
        per_appointment: '/ Termin',
        opens_at_checkin: 'Termine im Hotel (Massage, Sauna …) und Angebote von Partnern in der Nähe können Sie nach dem Check-in buchen.',
        room: 'Für welches Zimmer',
        appointments: 'TERMINE IM HOTEL',
        loading_times: 'Freie Termine werden geprüft …',
        times_failed: 'Freie Termine konnten nicht gelesen werden. Bitte versuchen Sie es erneut.',
        departed: 'Ihr Aufenthalt ist beendet — neue Termine können nicht mehr gebucht werden.',
        no_times: 'Bis zu Ihrer Abreise gibt es keine freien Termine.',
        departure_day: 'Am Abreisetag werden nur Termine angeboten, die bis {time} enden.',
        book: 'Buchen · {amount}',
        on_bill: 'auf die Zimmerrechnung',
        booked: 'Termin gebucht — {amount} auf Ihrer Zimmerrechnung.',
        book_failed: 'Der Termin konnte nicht gebucht werden — vielleicht wurde er gerade vergeben. Bitte wählen Sie erneut.',
        nearby: 'ANGEBOTE IN DER NÄHE',
        minutes: '{minutes} Min.',
        partner_down: 'Der Partner antwortet gerade nicht. Versuchen Sie es in einigen Minuten erneut oder fragen Sie an der Rezeption.',
        no_times_day: 'Der Partner hat an diesem Tag keine freien Termine.',
        partner_terms: 'Wir buchen den Termin bei {partner}. Bezahlt wird wie mit dem Hotel vereinbart — auf die Zimmerrechnung oder beim Partner.',
        nearby_done: 'Gebucht — man erwartet Sie.',
        taken: 'Dieser Termin wurde beim Partner gerade vergeben. Bitte wählen Sie einen anderen.',
        nearby_booked: 'IHRE TERMINE BEI PARTNERN',
        cancel: 'Stornieren',
        cancel_confirm: 'Stornierung bestätigen',
        cancel_changed: 'Die Stornokosten haben sich inzwischen geändert.',
        cancel_unknown: 'Für die Stornierung können die Bedingungen von {partner} gelten — fragen Sie an der Rezeption nach den Kosten oder bestätigen Sie die Stornierung.',
        cancel_late: 'Späte Stornierung: Der Partner berechnet {amount} auf Ihr Zimmer.',
        cancel_late_free: 'Die kostenlose Stornofrist ist abgelaufen, der Partner berechnet für diese Leistung aber nichts.',
        cancel_free: 'Die Stornierung ist bis {deadline} kostenlos.',
        cancel_gone: 'Dieser Termin kann hier nicht mehr storniert werden. Bitte fragen Sie an der Rezeption.',
        cancelled: 'Der Termin ist storniert.',
        cancelled_fee: 'Der Termin ist storniert. Der Partner berechnet {amount} auf Ihre Zimmerrechnung.',
        cancel_failed: 'Die Stornierung konnte nicht durchgeführt werden. Versuchen Sie es erneut oder fragen Sie an der Rezeption.',
    },
    order_pin: {
        title: 'PIN für Bestellungen',
        hint: 'Das Hotel fragt vor einer Bestellung oder Buchung nach Ihrer PIN. Sie haben sie beim Check-in an der Rezeption oder per E-Mail erhalten.',
        label: 'PIN',
        confirm: 'Bestätigen',
        wrong: 'Die PIN ist nicht richtig. Bitte versuchen Sie es erneut.',
        locked: 'Zu viele falsche Versuche. Versuchen Sie es in einigen Minuten erneut oder fragen Sie an der Rezeption.',
    },
    payment_done: {
        paid_title: 'Zahlung erfolgreich',
        paid_text: 'Vielen Dank! Die Zahlung wurde durchgeführt — die Rezeption sieht sie in wenigen Sekunden gebucht.',
        cancelled_title: 'Zahlung nicht durchgeführt',
        cancelled_text: 'Es wurde nichts belastet. Für einen neuen Versuch fragen Sie an der Rezeption.',
    },
    payments: {
        details_open: 'Bestellung ansehen',
        details_total: 'Gesamt',
        details_tax: 'davon MwSt. {rate} %: {amount}',
        title: 'Zahlungen und Rechnungen',
        reservation: 'Reservierung {number}',
        open_badge: 'Offen',
        folio_title: 'Aufenthaltsrechnung',
        due: 'Zu zahlen',
        pay_starting: 'Zahlung wird geöffnet …',
        pay_failed: 'Die Zahlung konnte nicht gestartet werden — versuchen Sie es erneut oder wenden Sie sich an die Rezeption.',
        paid_message: 'Zahlung erfolgreich. Vielen Dank!',
        method_cash: 'Bar',
        method_card: 'Karte',
        method_transfer: 'Überweisung',
        method_voucher: 'Gutschein',
        method_prepayment: 'Vorauszahlung',
        method_ota_virtual_card: 'virtuelle Karte',
        processing_title: 'Zahlung wird verarbeitet',
        processing_text: 'Wir warten auf die Bestätigung des Zahlungsanbieters. Das dauert in der Regel wenige Sekunden — die Seite meldet sich von selbst, sobald die Zahlung gebucht ist.',
        processing_timeout: 'Noch keine Bestätigung. Falls die Zahlung durchgeführt wurde, erscheint sie in Kürze unter den Positionen — andernfalls wenden Sie sich an die Rezeption.',
        overpaid_message: 'Der gezahlte Betrag ist höher als der offene — die Differenz gleicht die Rezeption als Guthaben aus.',
        cancelled_message: 'Die Zahlung wurde abgebrochen.',
        settled_badge: 'Beglichen',
        stripe_note: 'Die Karte geben Sie auf der sicheren Stripe-Seite ein; das Hotel sieht und speichert die Kartendaten nicht. Testumgebung.',
        pay_now: 'Jetzt bezahlen',
        proforma: 'Proformarechnung herunterladen',
        proforma_failed: 'Die Proformarechnung konnte nicht erstellt werden — bitte versuchen Sie es erneut.',
        invoices: 'Rechnungen',
        invoices_text: 'Die endgültige Rechnung ist nach Abschluss des Aufenthalts verfügbar.',
        documents: 'Dokumente',
        no_invoice_yet: 'Die endgültige Rechnung ist noch nicht ausgestellt.',
        secure_title: 'Sichere Zahlung',
        secure_text: 'Weder das Hotel noch Imprion speichert Ihre Kartendaten.',
        pay_title: 'Zahlung {amount}',
        simulated: 'Simulierte Zahlung — Ihre Karte wird nicht belastet.',
        simulated_done: 'Das war eine Simulation — die Online-Zahlung kommt mit einer der nächsten Versionen.',
        cardholder: 'Karteninhaber',
        card_number: 'Kartennummer',
        expiry_cvc: 'Gültig / CVC',
        pay_secure: 'Sicher bezahlen',
    },
    studio: {
        button: 'Portal anpassen',
        title: 'Anpassung des Hotelportals',
        hint: 'Vorschau zur Einrichtung eines einzelnen Objekts. Imprion Guest bleibt als Portalanbieter gekennzeichnet.',
        primary: 'Hauptfarbe',
        accent: 'Akzentfarbe',
        compact: 'kantigere Elemente',
        preview_only: 'Nur Vorschau — das Erscheinungsbild des Hauses speichert die Rezeption.',
    },
    license: {
        eyebrow: 'Online-Check-in',
        title: 'Dieser Service ist nicht aktiviert',
        lead: 'Dieses Hotel bietet keinen Online-Check-in an, daher lässt sich dieses Portal nicht öffnen. Ihre Reservierung bleibt davon unberührt.',
        another_link: 'Falls Sie inzwischen einen anderen Link erhalten haben, öffnen Sie ihn einfach — diese Seite wird dann neu geladen.',
        contact: 'Für alles rund um Ihren Aufenthalt wenden Sie sich bitte an die Rezeption — man hilft Ihnen dort gerne weiter.',
    },
    memory: {
        eyebrow: 'Erinnerung an Ihren Aufenthalt',
        thanks: 'Danke für Ihren Besuch',
        lead: 'Es war uns eine Freude. Hier bleibt eine kurze Erinnerung an Ihren Aufenthalt.',
        stayed: 'Aufenthalt',
        room: 'Zimmer',
        used: 'Was Sie genutzt haben',
        nights: 'Nächte',
        nights_one: '{n} Nacht',
        nights_two: '{n} Nächte',
        nights_few: '{n} Nächte',
        nights_many: '{n} Nächte',
        guests: 'Gäste',
        guests_one: '{n} Gast',
        guests_two: '{n} Gäste',
        guests_few: '{n} Gäste',
        guests_many: '{n} Gäste',
        book_again: 'Erneut buchen',
        invoice: 'Rechnung per E-Mail zusenden',
        invoice_sent: 'Die Rechnung wurde an die von Ihnen angegebene E-Mail-Adresse gesendet.',
        invoice_sending: 'Wird gesendet …',
        invoice_failed: 'Die Rechnung konnte gerade nicht gesendet werden. Bitte später erneut versuchen oder dem Hotel schreiben.',
        privacy: 'Diese Seite bleibt offen und enthält keine personenbezogenen Daten.',
    },
    invalid: {
        demo_opening: 'Aufenthalt wird geöffnet …',
        hotel_fallback: 'Ihr Hotel',
        reception: 'Rezeption',
        eyebrow: 'Benötigen Sie einen neuen Link?',
        title: 'Keine Sorge — wir erstellen schnell einen neuen',
        text: 'Aus Sicherheitsgründen ist dieser Link nicht mehr gültig. Ihre Reservierung ist damit nicht storniert und es sind keine Daten verloren gegangen.',
        help_title: 'So geht es weiter',
        step_contact_title: 'Wenden Sie sich an die Rezeption',
        step_contact_text: 'Rufen Sie das Hotel an oder senden Sie ihm eine kurze Nachricht.',
        step_identify_title: 'Nennen Sie den betreffenden Aufenthalt',
        step_identify_text: 'Der Name des Gastes und das voraussichtliche Ankunftsdatum genügen.',
        step_open_title: 'Öffnen Sie den neuen Link',
        step_open_text: 'Das Hotel sendet ihn Ihnen per E-Mail oder Nachricht.',
        retry: 'Erneut versuchen',
        security: 'Wir begrenzen die Gültigkeit der Links zeitlich, um die Daten Ihres Aufenthalts zu schützen.',
    },
    /*
     * Hiša — vsebina sobnih televizorjev na telefonu (docs/DISPLAY.md §9).
     *
     * Svoj imenski prostor, ker je to stavba in ne bivanje: isto besedilo vidi vsak gost
     * v hiši, ne glede na svojo rezervacijo. Izrazje je namenoma isto kot na zaslonih
     * (`house.*`, `local.kind_*` v pms-display), da hiša na steni in na telefonu ne
     * govori dveh jezikov.
     */
    house: {
        sign_up: 'Uns anmelden',
        signed_up: 'Angemeldet',
        signup_count: '{count} angemeldet',
        guest_deal: 'Für Hotelgäste: {deal}',
        voucher_title: 'Ihr Rabattgutschein',
        voucher_open: 'Gutschein öffnen',
        voucher_note: 'Zeigen Sie den QR-Code vor oder öffnen Sie den Link beim Partner — die Seite bestätigt live, dass Sie Gast des Hotels sind.',
        locked_eye: 'Wird beim Check-in freigeschaltet',
        locked_text: 'Die Hausinhalte — WLAN, Willkommensbrief, Programm und Umgebung — werden auf Ihrem Telefon beim Check-in im Hotel freigeschaltet. Wir sehen uns an der Rezeption!',
        title: 'Das Haus',
        loading: 'Wird geladen …',
        failed: 'Die Hausinhalte können zurzeit nicht angezeigt werden. Bitte versuchen Sie es in einigen Momenten erneut.',
        section_house: 'WILLKOMMEN',
        section_letter: 'WILLKOMMENSBRIEF',
        section_today: 'HEUTE IM HAUS',
        section_weather: 'WETTER',
        section_services: 'LEISTUNGEN UND PREISE',
        section_events: 'VERANSTALTUNGEN IN DER UMGEBUNG',
        section_places: 'SEHENSWÜRDIGKEITEN IN DER UMGEBUNG',
        wifi: 'WLAN-Netzwerk',
        network: 'Netzwerk',
        password: 'Passwort',
        wifi_open: 'Das Netzwerk ist offen, Sie benötigen kein Passwort.',
        hours: 'Öffnungszeiten',
        phone_keys: 'Telefontasten',
        room_phone: 'Vom Zimmertelefon.',
        emergency: 'Notruf',
        per_day: '/ Tag',
        per_item: '/ einmalig',
        to_services: 'Leistung reservieren',
        open_in_maps: 'In Google Maps öffnen',
        kind_sight: 'Sehenswürdigkeit',
        kind_restaurant: 'Wo Sie essen können',
        kind_activity: 'Aktivität',
        kind_shop: 'Einkaufen',
        kind_other: 'Weiteres in der Umgebung',
    },
    /* Napoved je Open-Meteo; `weather` je beseda za nebo, ki jo prevede zaslon. */
    weather: {
        today: 'heute',
        rain_chance: '{percent} %',
        clear: 'klar',
        partly_cloudy: 'teilweise bewölkt',
        overcast: 'bewölkt',
        fog: 'Nebel',
        drizzle: 'Nieselregen',
        rain: 'Regen',
        rain_showers: 'Schauer',
        snow: 'Schnee',
        snow_showers: 'Schneeschauer',
        thunderstorm: 'Gewitter',
    },
    /*
     * Milo, the house's assistant in the guest's own hands.
     *
     * Short sentences on purpose: this is read on a telephone, standing up, usually with
     * one hand. `executed` says "handed over" and never "done" — every one of the four
     * actions is a REQUEST the hotel then acts on, and a portal that said "done" would
     * be promising on the hotel's behalf.
     *
     * `result.*` is what a confirmed proposal DID, keyed by the outcome code the service
     * sends. The Slovenian 1/2/3-4/5+ forms are chosen in `libs/chatResult.ts` and not by
     * vue-i18n, for the reason written there; the other languages carry the same four
     * keys so that the two locale files never disagree about which keys exist.
     */
    milo: {
        title: 'Milo',
        greeting: 'Hallo, ich bin Milo.',
        intro: 'Fragen Sie mich zum Hotel und zu Ihrem Aufenthalt — ich antworte in Ihrer Sprache.',
        placeholder: 'Frage schreiben …',
        send: 'Senden',
        thinking: 'Milo denkt nach …',
        still_working: 'Ich suche noch — das kann eine Minute dauern.',
        disclaimer: 'Milo ist der Assistent des Hotels. Er nimmt keine Zahlungen entgegen und stellt keine Rechnungen aus; für alles Weitere ist die Rezeption da.',
        open: 'Milo öffnen',
        close: 'Schließen',
        chip_wifi: 'WLAN',
        chip_wifi_text: 'Wie lautet das WLAN-Passwort?',
        chip_breakfast: 'Frühstück',
        chip_breakfast_text: 'Bis wann gibt es Frühstück?',
        chip_late_checkout: 'Später Check-out',
        chip_late_checkout_text: 'Kann ich etwas länger im Zimmer bleiben?',
        chip_today: 'Was ist heute los',
        chip_today_text: 'Was ist heute in der Umgebung los?',
        confirm: 'Bestätigen',
        decline: 'Nein, jetzt nicht',
        executed: 'Übermittelt',
        declined: 'Nicht übermittelt.',
        failed: 'Das hat nicht geklappt. Versuchen Sie es erneut oder rufen Sie die Rezeption an.',
        expired: 'Dieser Vorschlag ist abgelaufen. Fragen Sie bitte noch einmal.',
        already_decided: 'Über diesen Vorschlag wurde bereits entschieden.',
        card_closed: 'Dieser Vorschlag kann nicht mehr bestätigt werden.',
        budget_spent: 'Für heute sind genug Fragen gestellt. Morgen wieder, oder rufen Sie die Rezeption an.',
        throttled: 'Einen Moment — versuchen Sie es in ein paar Sekunden noch einmal.',
        too_long: 'Milo hat für diese Frage zu lange gebraucht. Fragen Sie etwas Genaueres, oder rufen Sie die Rezeption an.',
        interrupted: 'Milo wurde beim Antworten unterbrochen. Fragen Sie bitte noch einmal.',
        unavailable: 'Milo ist gerade nicht verfügbar. Die Rezeption hilft Ihnen gern.',
        result: {
            late_checkout_requested:    'Ihre Anfrage für einen späten Check-out liegt bei der Rezeption.',
            guest_service_booked_one:   'Für {count} Tag gebucht.',
            guest_service_booked_two:   'Für {count} Tage gebucht.',
            guest_service_booked_few:   'Für {count} Tage gebucht.',
            guest_service_booked_other: 'Für {count} Tage gebucht.',
            room_request_raised:        'Ihre Anfrage liegt bei der Zimmerreinigung.',
            reception_message_sent:     'Ihre Nachricht liegt bei der Rezeption.',
            room_service_ordered_one:   'Die Küche hat Ihre Bestellung: {count} Position, {detail}.',
            room_service_ordered_two:   'Die Küche hat Ihre Bestellung: {count} Positionen, {detail}.',
            room_service_ordered_few:   'Die Küche hat Ihre Bestellung: {count} Positionen, {detail}.',
            room_service_ordered_other: 'Die Küche hat Ihre Bestellung: {count} Positionen, {detail}.',
            lost_item_reported:         'Ihre Meldung ist unter {detail} eingetragen; die Rezeption meldet sich.',
            transfer_requested:         'Ihre Transferanfrage ({detail}) liegt bei der Rezeption.',
        },
    },
}
